import { HwTypeKey } from "@const/hwTypeKey.constants";
import { MenuNode } from "src/model/MenuNode";

const LAN_GROUP_TYPES = [HwTypeKey.LANOTHERS, HwTypeKey.LANCISCO, HwTypeKey.FIREWALLCISCO] as string[];

/** True for hw types whose items live under LAN/firewall "group" nodes instead of an own type node. */
export function isLanGroupType(typeOrDevice: string): boolean {
  return LAN_GROUP_TYPES.includes(typeOrDevice);
}

/**
 * Picks the group node matching the ':::'-suffixed group id from the item search,
 * or the last group otherwise, and stamps it with the requested hwType.
 */
export function findLanGroupType(nodes: MenuNode[], typeOrDevice: string, itemSearch: string): MenuNode {
  const split = itemSearch.split(":::");
  let typ: MenuNode;
  for (const node of nodes) {
    if (node.subsystem === "group" && (split.length < 2 || node.itemId === split[1])) {
      typ = node;
      typ.hwType = typeOrDevice;
    }
  }
  return typ;
}
